import RoutesRedirect from './RoutesRedirect'

export default RoutesRedirect
